import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import '../../utils/responsive.es.js';
import { useIsDestroyed } from '../../hooks/useIsDestroyed/useIsDestroyed.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

function importDayJSLocale(language) {
  var importFunctions = {
    en: function en() {
      return import('dayjs/locale/en.js');
    },
    fr: function fr() {
      return import('dayjs/locale/fr.js');
    },
    de: function de() {
      return import('dayjs/locale/de.js');
    },
    it: function it() {
      return import('dayjs/locale/it.js');
    },
    ja: function ja() {
      return import('dayjs/locale/ja.js');
    },
    pt: function pt() {
      return import('dayjs/locale/pt.js');
    },
    es: function es() {
      return import('dayjs/locale/es.js');
    }
  };
  var importFunction = importFunctions[language];
  return importFunction ? importFunction() : Promise.reject("Unsupported locale");
}

var useUpdatingTimestamp = function useUpdatingTimestamp(_ref) {
  var createdAt = _ref.createdAt,
      locale = _ref.locale;

  var _useState = useState(dayjs(createdAt).fromNow()),
      timestamp = _useState[0],
      setTimestamp = _useState[1];

  var isDestroyed = useIsDestroyed();
  useEffect(function () {
    if (locale) {
      importDayJSLocale(locale).then(function () {
        if (!isDestroyed.current) {
          dayjs.locale(locale);
          setTimestamp(dayjs(createdAt).fromNow());
        }
      }).catch(function () {
        if (!isDestroyed.current) {
          dayjs.locale("en");
          setTimestamp(dayjs(createdAt).fromNow());
        }
      });
    }
  }, [createdAt, isDestroyed, locale]);
  useEffect(function () {
    var createdAtDayjs = dayjs(createdAt);
    var diffInSeconds = Math.abs(createdAtDayjs.diff(dayjs(), "second"));
    var sInHour = 3600;
    var intervalId = void 0;

    if (diffInSeconds < sInHour) {
      intervalId = setInterval(function () {
        setTimestamp(createdAtDayjs.fromNow());
      }, 6e4);
    }

    return function () {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [createdAt, timestamp]);
  return {
    timestamp: timestamp
  };
};

var RichTimestamp = function RichTimestamp(_ref2) {
  var createdAt = _ref2.createdAt,
      checkSamePeriod = _ref2.checkSamePeriod,
      _ref2$locale = _ref2.locale,
      locale = _ref2$locale === void 0 ? "en" : _ref2$locale,
      _ref2$format = _ref2.format,
      format = _ref2$format === void 0 ? "ll" : _ref2$format;

  var _useUpdatingTimestamp = useUpdatingTimestamp({
    createdAt: createdAt,
    locale: locale
  }),
      timestamp = _useUpdatingTimestamp.timestamp;

  var createdAtDayJs = dayjs(createdAt);
  var fullLocalizedDate = createdAtDayJs.format(format);

  if (createdAtDayJs.isAfter(dayjs())) {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null, fullLocalizedDate)
    );
  }

  if (!checkSamePeriod || createdAtDayJs.diff(dayjs(), checkSamePeriod) >= 0) {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null, timestamp)
    );
  }

  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, fullLocalizedDate)
  );
};

export { RichTimestamp };